import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { cleanSearchingCountrysPaginated, countryClean } from "../../app/actions/catalogCountryActions";
import ReactTooltip from "react-tooltip";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import DisplayNameAndRole from "./DisplayNameAndRole";

const NavbarIconsCountries = ({ page }) => {
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

    const { isUserAuthenticated } = useSelector((state) => state.auth);

  const [activeIcon, setActiveIcon] = useState(null);

  const handleActiveIcon = (icon) => {
    
    if (icon === "new") {
      
      trackEvent({ component: "NewCountries", event: "NewCountries-Clicked" });
    } else if (icon === "list") {
      
      trackEvent({ component: "ListCountries", event: "ListCountries-Clicked" });
      dispatch(cleanSearchingCountrysPaginated());
    }

    dispatch(countryClean());
    setActiveIcon(icon);
  };

  const iconActiveStyle = (icon) => {
    if (activeIcon === icon) {
      return "icon-d-flex active";
    } else {
      return "icon-d-flex";
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-nowrap gradient-custom-sky custom-nav-height">
      {isUserAuthenticated && (
        <DisplayNameAndRole />
      )}
      {page === "listCountries" && (
        <Link
          data-tip
          data-for="newCountriesTip"
          to="/admin-country/new-country"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("new")}
        >
          <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "newCountries" && (
        <Link
          data-tip
          data-for="listCountriesTip"
          to="/admin-country/"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("list")}
        >
          <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "editCountries" && (
        <div className="navbar-module-actions">
          <Link
            data-tip
            data-for="listCountriesTip"
            to="/admin-country/"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("list")}
          >
            <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
          </Link>
          <Link
            data-tip
            data-for="newCountriesTip"
            to="/admin-country/new-country"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("new")}
          >
            <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
          </Link>
        </div>
      )}

      <ReactTooltip id="newCountriesTip" place="left" effect="solid">
        {t("admin-country.page.register")}
      </ReactTooltip>
      <ReactTooltip id="listCountriesTip" place="left" effect="solid">
        {t("admin-country.page.list")}
      </ReactTooltip>
    </div>
  );
};

export default NavbarIconsCountries;
